<div class="wrapper">
  <app-header></app-header>
  <app-menu (changePageMenu)="changePage($event)"></app-menu>
  <div class="content-wrapper">
    <ng-template #pageRouter></ng-template>
  </div>
  <app-footer></app-footer>
</div>